import {
  GET_COMMENTS_SUCCESS,
  CREATE_COMMENT_SUCCESS,
  UPDATE_COMMENT_SUCCESS,
  DELETE_COMMENT_SUCCESS,
  GET_UNRESOLVED_COUNTS_SUCCESS,
} from './comment.types';

const initialState = {
  comments: [],
  unresolvedCounts: {}, // { taskId: count }
};

export const commentReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_COMMENTS_SUCCESS:
      return { ...state, comments: action.payload };
    case CREATE_COMMENT_SUCCESS: {
      const newComment = action.payload;
      const tid = typeof newComment.task === 'object' ? newComment.task._id : newComment.task;
      const newCounts = { ...state.unresolvedCounts };
      if (!newComment.resolved) {
        newCounts[tid] = (newCounts[tid] || 0) + 1;
      }
      return { ...state, comments: [newComment, ...state.comments], unresolvedCounts: newCounts };
    }
    case UPDATE_COMMENT_SUCCESS: {
      const updated = action.payload;
      const prev = state.comments.find((c) => c._id === updated._id);
      const tid2 = typeof updated.task === 'object' ? updated.task._id : updated.task;
      const newCounts2 = { ...state.unresolvedCounts };
      // If resolved changed, update count
      if (prev && prev.resolved !== updated.resolved) {
        if (updated.resolved) {
          newCounts2[tid2] = Math.max(0, (newCounts2[tid2] || 1) - 1);
        } else {
          newCounts2[tid2] = (newCounts2[tid2] || 0) + 1;
        }
      }
      return {
        ...state,
        comments: state.comments.map((c) => c._id === updated._id ? updated : c),
        unresolvedCounts: newCounts2,
      };
    }
    case DELETE_COMMENT_SUCCESS: {
      const deleted = state.comments.find((c) => c._id === action.payload);
      const newCounts3 = { ...state.unresolvedCounts };
      if (deleted && !deleted.resolved) {
        const tid3 = typeof deleted.task === 'object' ? deleted.task._id : deleted.task;
        newCounts3[tid3] = Math.max(0, (newCounts3[tid3] || 1) - 1);
      }
      return {
        ...state,
        comments: state.comments.filter((c) => c._id !== action.payload),
        unresolvedCounts: newCounts3,
      };
    }
    case GET_UNRESOLVED_COUNTS_SUCCESS:
      return { ...state, unresolvedCounts: action.payload };
    default:
      return state;
  }
};
